import { suppliesCollectionIdFormat } from "@redotech/redo-marketplace-id";
import { FilterGroupSchema } from "@redotech/redo-views-common/advanced-filters/advanced-filter-data";
import * as z from "zod";

const SuppliesCollectionSchema_ = z.object({
  id: suppliesCollectionIdFormat.schema,
  title: z.string(),
  conditionsFilterGroup: FilterGroupSchema,
  createdAt: z.date(),
  updatedAt: z.date(),
});
export const SuppliesCollectionSchema: z.ZodType<SuppliesCollection> =
  SuppliesCollectionSchema_;
export interface SuppliesCollection extends z.infer<
  typeof SuppliesCollectionSchema_
> {}
